import { Path } from "./Path";
import {
  POST_DATA_NOTOKEN_MYAPI,
  GET_TOKEN_MYAPI,
  POST_MYAPI_UPLOAD_FILE,
  POST_MYAPI,
  GET_TOKEN_MYAPI_RECAPTCHA,
  GET_MYAPI_TOKEN,
  GET_MYAPI_NOT_TOKEN,
  GET_MYAPI_WITH_CREDENTIALS,
  GET_MYAPI_BLOB_WITH_CREDENTIALS,
  POST_MYAPI_WITH_CREDENTIALS,
} from "./Fetch";

import { handleGetToken } from "../Share/Func/Storage";

export const Api = {
  _getLoginToken: Path.API + "get-token-domain",
  _insSignup: Path.urlApi + "account",
  _batchSignup: Path.urlApi + "users/batch-sign-up",
  _UpdateProfile: Path.urlApi + "update-profile",
  _getVerifyCode: Path.urlApi + "get-verify-code",
  _sendZaloOtp: Path.urlApi + "zalo/send-otp",
  _sendEmailOtp: Path.urlApi + "email/send-otp",
  _updateInvoiceInfo: Path.urlApi + "update-invoice-info",
  _sendSms: Path.urlApi + "send-sms",
  _rePassword: Path.urlApi + "re-password",
  _loginGame: Path.urlApi + "login",
  _getUser: Path.urlApi + "user",
  _logout: Path.urlApi + "logout",
  _sendRequestDeleteAccount: Path.urlApi + "send-request-delete-account",
  _changPass: Path.urlApi + "change-password",
  _getToken: Path.urlApi + "getToken",
  _News: Path.urlApi + "get-new",
  _NewNotToken: Path.urlApi + "get-new-not-token",
  _uploadFile: Path.urlApi + "upload-file",
  _login2: Path.urlApi + "admin-login-by-Verification",
  _dashboard: Path.urlApi + "knb/get-dashboard",
  _verifyCaptCha_v3: Path.urlApi + "recaptcha/v3",
  _addKnb: Path.urlApi + "knb/add-knb",
  _getHistory: Path.urlApi + "history",
  _adminMisaInvoiceView: Path.urlApi + "admin/history/misa-invoice-view",
  _userMisaInvoiceView: Path.urlApi + "user/history/misa-invoice-view",
  _userDownloadInvoice: Path.urlApi + "user/download-invoice",
  _adminLogin: Path.urlApi + "auth/admin-login",
  _getUsers: Path.urlApi + "users",
  _vouchers: Path.urlApi + "voucher",
  _voucher_delete: Path.urlApi + "voucher/delete",
  _voucher_update: Path.urlApi + "voucher/update",
  _voucherHistories: Path.urlApi + "voucher-history",
  _voucherGlobal: Path.urlApi + "voucher-global",
  _voucherValidation: Path.urlApi + "voucher-validation",
  _userHistories: Path.urlApi + "user-histories",
  _items: Path.urlApi + "items",
  _addItems: Path.urlApi + "items",
  _deleteItem: Path.urlApi + "item/delete",
  _adminVerifyCode: Path.urlApi + "auth/admin-verify",
  _adminRateLimit: Path.urlApi + "rate-limits",
  _news: Path.urlApi + "news",
  _sepayEvents: Path.urlApi + "sepay-events",
  _misaManualInvoice: Path.urlApi + "misa/manual-invoice",
};

export const CallApiUpdateProfile = (token, data, handleData) => {
  GET_TOKEN_MYAPI_RECAPTCHA(Api._UpdateProfile, token, data, async (res) => {
    handleData(res);
  });
};
export const SIGNUP_API = (token, body, handleData) => {
  GET_TOKEN_MYAPI_RECAPTCHA(Api._insSignup, token, body, async (res) => {
    handleData(res);
  });
};

export const BATCH_SIGNUP_API = (token, body, handleData) => {
  GET_TOKEN_MYAPI_RECAPTCHA(Api._batchSignup, token, body, async (res) => {
    handleData(res);
  });
};

export const CallApiGetVerifyCode = (data, handleData) => {
  GET_TOKEN_MYAPI(Api._getVerifyCode, data, async (res) => {
    handleData(res);
  });
};

export const CallApiSendZaloOtp = (data, handleData) => {
  GET_TOKEN_MYAPI(Api._sendZaloOtp, data, async (res) => {
    handleData(res);
  });
};

export const CallApiSendEmailOtp = (token, data, handleData) => {
  GET_TOKEN_MYAPI_RECAPTCHA(Api._sendEmailOtp, token, data, async (res) => {
    handleData(res);
  });
};

export const CallApiUpdateInvoiceInfo = (token, data, handleData) => {
  GET_TOKEN_MYAPI_RECAPTCHA(
    Api._updateInvoiceInfo,
    token,
    data,
    async (res) => {
      handleData(res);
    }
  );
};

export const CallApiSendSms = (token, data, handleData) => {
  GET_TOKEN_MYAPI_RECAPTCHA(Api._sendSms, token, data, async (res) => {
    handleData(res);
  });
};

export const CallApiRePassword = (token, data, handleData) => {
  GET_TOKEN_MYAPI_RECAPTCHA(Api._rePassword, token, data, async (res) => {
    handleData(res);
  });
};

export const CallApiSignIn = (token, data, handleData) => {
  GET_TOKEN_MYAPI_RECAPTCHA(Api._loginGame, token, data, async (res) => {
    handleData(res);
  });
};

export const CallApiGetUser = (handleData) => {
  GET_MYAPI_WITH_CREDENTIALS(Api._getUser, async (res) => {
    handleData(res);
  });
};

export const CallApiLogout = (handleData) => {
  POST_MYAPI_WITH_CREDENTIALS(Api._logout, {}, async (res) => {
    handleData(res);
  });
};

export const CallApiSendRequestDeleteAccount = (handleData) => {
  POST_MYAPI_WITH_CREDENTIALS(
    Api._sendRequestDeleteAccount,
    {},
    async (res) => {
      handleData(res);
    }
  );
};

export const CallApiChangePass = (token, data, handleData) => {
  GET_TOKEN_MYAPI_RECAPTCHA(Api._changPass, token, data, async (res) => {
    handleData(res);
  });
};

export const CallApiNotLogin2 = (Data, handleData) => {
  POST_DATA_NOTOKEN_MYAPI(Api._login2, Data, (res) => {
    handleData(res);
  });
};

export const CallApiUpLoadFile = (data, handleData) => {
  POST_MYAPI_UPLOAD_FILE(Api._uploadFile, data, handleGetToken(), (res) => {
    handleData(res);
  });
};

export const CallApiVerifyCaptcha_V3 = (data, handleData) => {
  POST_DATA_NOTOKEN_MYAPI(Api._verifyCaptCha_v3, data, (res) => {
    handleData(res);
  });
};
export const CallApiGetDashboard = (data, token, handleData) => {
  var url = `${Api._dashboard}?month=${data.month}&year=${data.year}`;
  GET_MYAPI_TOKEN(url, token, (res) => {
    handleData(res);
  });
};

export const CallGameAddKnb = (Data, handleData) => {
  POST_MYAPI(Api._addKnb, Data, handleGetToken(), (res) => {
    handleData(res);
  });
};

export const CallApiGetHistory = (data, handleData) => {
  var url = `${Api._getHistory}?type=${data.type}&searchText=${data.searchText}&page=${data.page}`;
  GET_MYAPI_TOKEN(url, handleGetToken(), (res) => {
    handleData(res);
  });
};

export const CallApiGetMisaInvoiceView = (historyId, handleData) => {
  var url = `${Api._adminMisaInvoiceView}?historyId=${encodeURIComponent(
    historyId
  )}`;
  GET_MYAPI_TOKEN(url, handleGetToken(), (res) => {
    handleData(res);
  });
};

export const CallApiGetUserMisaInvoiceView = (historyId, handleData) => {
  var url = `${Api._userMisaInvoiceView}?historyId=${encodeURIComponent(
    historyId
  )}`;
  GET_MYAPI_WITH_CREDENTIALS(url, (res) => {
    handleData(res);
  });
};

export const CallApiDownloadInvoice = (historyId, handleData) => {
  var url = `${Api._userDownloadInvoice}?historyId=${encodeURIComponent(
    historyId
  )}`;
  GET_MYAPI_BLOB_WITH_CREDENTIALS(url, (res) => {
    handleData(res);
  });
};

export const CallApiAdminSignIn = (reCaptchaToken, body, handleData) => {
  GET_TOKEN_MYAPI_RECAPTCHA(Api._adminLogin, reCaptchaToken, body, (res) => {
    handleData(res);
  });
};

export const CallApiGetListUser = (data, handleData) => {
  var url = `${Api._getUsers}?searchText=${data.searchText}&page=${data.page}`;
  GET_MYAPI_TOKEN(url, handleGetToken(), (res) => {
    handleData(res);
  });
};

export const CallApiGetVoucher = (data, handleData) => {
  var url = `${Api._vouchers}?searchText=${data.searchText}&page=${data.page}&isDeleted=${data.isDeleted}`;
  GET_MYAPI_TOKEN(url, handleGetToken(), (res) => {
    handleData(res);
  });
};
export const CallApiGetVoucherHistories = (data, handleData) => {
  var url = `${Api._voucherHistories}?searchText=${data.searchText}&page=${data.page}`;
  GET_MYAPI_TOKEN(url, handleGetToken(), (res) => {
    handleData(res);
  });
};

export const CallApiCreateVoucher = (data, handleData) => {
  POST_MYAPI(Api._vouchers, data, handleGetToken(), (res) => {
    handleData(res);
  });
};

export const CallApiDeleteVoucher = (data, handleData) => {
  var url = `${Api._voucher_delete}?id=${data}`;
  POST_MYAPI(url, data, handleGetToken(), (res) => {
    handleData(res);
  });
};

export const CallApiUpdateVoucher = (code, data, handleData) => {
  var url = `${Api._voucher_update}?code=${code}`;
  POST_MYAPI(url, data, handleGetToken(), (res) => {
    handleData(res);
  });
};

export const CallApiGetVoucherGlobal = (data, handleData) => {
  POST_MYAPI(Api._voucherGlobal, data, handleGetToken(), (res) => {
    handleData(res);
  });
};

export const CallApiGetUserHistories = (param, handleData) => {
  let url = `${Api._userHistories}`;

  POST_DATA_NOTOKEN_MYAPI(url, param, (res) => {
    handleData(res);
  });
};

export const CallApiGetVoucherValidation = (model, handleData) => {
  var url = `${Api._voucherValidation}`;

  POST_DATA_NOTOKEN_MYAPI(url, model, (res) => {
    handleData(res);
  });
};

export const CallApiGetItems = (handleData) => {
  GET_MYAPI_TOKEN(Api._items, handleGetToken(), (res) => {
    handleData(res);
  });
};

export const CallApiCreateItem = (data, handleData) => {
  POST_MYAPI(Api._items, data, handleGetToken(), (res) => {
    handleData(res);
  });
};

export const CallApiDeleteItem = (data, handleData) => {
  var url = `${Api._deleteItem}?userId=${data}`;
  POST_MYAPI(url, data, handleGetToken(), (res) => {
    handleData(res);
  });
};

export const CallApiAdminVerify = (body, handleData) => {
  POST_DATA_NOTOKEN_MYAPI(Api._adminVerifyCode, body, (res) => {
    handleData(res);
  });
};

export const CallApiGetNews = (param, handleData) => {
  const url = `${Api._news}?type=${param.type}&page=${param.page}&pageSize=${param.pageSize}&searchText=${param.search}`;
  GET_MYAPI_NOT_TOKEN(url, (res) => {
    handleData(res);
  });
};

export const CallApiGetNewById = (id, handleData) => {
  const url = `${Api._news}/${id}`;
  GET_MYAPI_NOT_TOKEN(url, (res) => {
    handleData(res);
  });
};
export const CallApiDeleteNew = (id, handleData) => {
  var url = `${Api._news}/remove/${id}`;
  GET_MYAPI_TOKEN(url, handleGetToken(), (res) => {
    handleData(res);
  });
};

export const CallApiCreateNew = (data, handleData) => {
  POST_MYAPI(Api._news, data, handleGetToken(), (res) => {
    handleData(res);
  });
};

export const CallApiUpdateNew = (id, data, handleData) => {
  const url = `${Api._news}/update/${id}`;
  POST_MYAPI(url, data, handleGetToken(), (res) => {
    handleData(res);
  });
};

export const CallApiGetRateLimits = (data, handleData) => {
  var url = `${Api._adminRateLimit}?search=${data.searchText}&function=${data.functionName}&page=${data.page}&pageSize=${data.pageSize}`;
  GET_MYAPI_TOKEN(url, handleGetToken(), (res) => {
    handleData(res);
  });
};

export const CallApiGetSepayEvents = (data, handleData) => {
  var url = `${Api._sepayEvents}?searchText=${data.searchText}&page=${data.page}&pageSize=${data.pageSize}`;
  if (data.fromDate) url += `&fromDate=${data.fromDate}`;
  if (data.toDate) url += `&toDate=${data.toDate}`;
  GET_MYAPI_TOKEN(url, handleGetToken(), (res) => {
    handleData(res);
  });
};

export const CallApiGetSepayEventById = (id, handleData) => {
  var url = `${Api._sepayEvents}/${encodeURIComponent(id)}`;
  GET_MYAPI_TOKEN(url, handleGetToken(), (res) => {
    handleData(res);
  });
};

export const CallApiCreateManualInvoice = (data, handleData) => {
  POST_MYAPI(Api._misaManualInvoice, data, handleGetToken(), (res) => {
    handleData(res);
  });
};

export const CallApiResetRateLimit = (data, handleData) => {
  var url = `${Api._adminRateLimit}/reset`;
  POST_MYAPI(url, data, handleGetToken(), (res) => {
    handleData(res);
  });
};
